






























import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class DashboardAside extends Vue {
  logined: boolean = false
  visible: boolean = false
  routeName: object = {
    'dashboard-index': '工作台',
    'monthly-report': '填写月报'
    // 'q1-report': '填写第一季度季报',
    // 'change-password': '修改密码'
  }
  user: any = {}
  roles: any = {
    super_admin: [
      'dashboard-index',
      // 'change-password',
      'monthly-report'
      // 'q1-report'
    ]
  }
  routes: string[] = []

  created() {
    let role = 'super_admin'
    this.routes = this.roles[role]
    console.log(this.routes)
    this.user = JSON.parse(localStorage.getItem('account') || '')
    // this.routes = this.roles[this.user.role];
  }
}
